import React from 'react';
import { Link } from 'react-router-dom';
import { Printer } from 'lucide-react';
import PartnerBriefSheet from '../components/PartnerBriefSheet';

const PartnerBrief: React.FC = () => {
  return (
    <div className="bg-paper-dark/80 py-10 px-4 print:bg-white print:py-0 print:px-0">
      <div className="max-w-[210mm] mx-auto mb-6 flex flex-wrap items-center justify-between gap-3 no-print">
        <Link to="/partenaires" className="text-sm text-ink-muted hover:text-ink">
          ← Partenariats
        </Link>
        <button type="button" className="btn btn-primary" onClick={() => window.print()}>
          <Printer className="h-4 w-4 mr-2" />
          Enregistrer en PDF
        </button>
      </div>
      <p className="no-print max-w-[210mm] mx-auto mb-4 text-xs text-ink-faint">
        Dans la boîte d’impression : destination « Enregistrer au format PDF », format A4, marges
        par défaut.
      </p>
      <div className="max-w-[210mm] mx-auto shadow-card print:shadow-none">
        <PartnerBriefSheet />
      </div>
    </div>
  );
};

export default PartnerBrief;
